import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, EffectFade } from 'swiper/modules';

class InteractiveCarouselModule {
    constructor(selector) {
        this.selector = selector;
        this.swipers = [];

        this.initSliders();
        this.updateSliders = this.updateSliders.bind(this);
        window.addEventListener('resize', this.updateSliders);
    }

    initSliders() {
        const parentContainers = document.querySelectorAll('.c-interactive-carousel');

        parentContainers.forEach((parentContainer) => {
            const containers = parentContainer.querySelectorAll(this.selector);
              
            containers.forEach((container) => {
                const swiperInstance = new Swiper(container, {
                    modules: [Navigation, EffectFade],
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    speed: 0,
                    navigation: {
                        nextEl: container.querySelector('.swiper-button-next'),
                        prevEl: container.querySelector('.swiper-button-prev'),
                    },
                });

                swiperInstance.on('slideChange', () => {
                    const slides = container.querySelectorAll('.swiper-slide');
                    slides.forEach((slide, index) => {
                        const image = slide.querySelector('img.js-gif');
                        if (image) {
                            if (index === swiperInstance.activeIndex) {
                                image.src = image.dataset.originalSrc;
                            } else {
                                image.dataset.originalSrc = image.src;
                                image.src = '';
                            }
                        }
                    });
                    setActiveButton();
                });

                const buttons = parentContainer.querySelectorAll('[data-interactive-carousel-button]');

                const setActiveButton = () => {
                    const activeSlideIndex = swiperInstance.activeIndex;

                    buttons.forEach((btn, index) => {
                        if (index === activeSlideIndex) {
                            btn.classList.add('active');
                        } else {
                            btn.classList.remove('active');
                        }
                    });
                };

                buttons.forEach((button, index) => {
                    button.addEventListener('click', (event) => {
                        event.preventDefault();
                        swiperInstance.slideTo(index);
                    });
                });

                setActiveButton();

                this.swipers.push(swiperInstance);
            });
        });

        this.updateSliders();
    };

    updateSliders() {
        this.swipers.forEach((swiper) => {
            swiper.update();
        });
    }
}

export default InteractiveCarouselModule;
